<div [ngClass]="{ active: active, blink: blink }"></div>
